module.exports = __webpack_public_path__ + "8be25b0290ad147c60318826493d69e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/location/locationMobile@3x.png
// module id = 740
// module chunks = 0